export enum UserRole {
    Factor = 'factor',
    Editor = 'editor',
    Viewer = 'viewer',

    Developer = 'developer',
    Charges = 'charges',

    Buyer = 'buyer',
    BuyerOwner = 'buyer - owner',

    Supplier = 'supplier',
    SupplierViewer = 'supplier - viewer',
    SupplierInvoiceCoordinator = 'supplier - invoice coordinator',
    SupplierBuyersManager = 'supplier - buyers manager',
    SupplierSalesManager = 'supplier - sales manager',
    SupplierBuyerFinancialManager = 'supplier - Financial Manager',
    SupplierCreditReviewer = 'supplier - credit reviewer',

    Guest = 'guest',
    SupplierM2M = 'supplier - m2m',
    BusinessMatcher = 'business matcher',

    SwitchRoles = 'switch roles',
    Allianz = 'allianz',
    Refund = 'refund',
    ExternalSync = 'supplier - external sync',
    Fund = 'fund',
    Checkout = 'checkout',
    GuestCreditLine = 'guest-credit-line',
    GuestLanding = 'guest-landing',
    Assistant = 'assistant',
    SolutionIntegrator = 'solution-integrator',
}

export const SupplierRoles: UserRole[] = [
    UserRole.Supplier,
    UserRole.SupplierViewer,
    UserRole.SupplierInvoiceCoordinator,
    UserRole.SupplierBuyersManager,
    UserRole.SupplierSalesManager,
    UserRole.SupplierBuyerFinancialManager,
    UserRole.SupplierCreditReviewer,
];

export const BuyerRoles: UserRole[] = [UserRole.Buyer, UserRole.BuyerOwner];

export const AdminRoles: UserRole[] = [UserRole.Factor, UserRole.Editor, UserRole.Viewer];

export const SwitchRoles = 'switch-roles';
